import { GridColumnModel } from './grid-column.model';

export class DatatableData {
	parentKey: any;
	page: number = 1;
	pageSize: number = 20;
	total: number = 0;
	columns: GridColumnModel[];
	items: any[] = [];
	sort: string;
	sortField: string;
	filters: any = {};
	selectedItems: any[] = [];
}
